import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api } from './api';
const fmtMin = m => m == null ? '—' : m < 60 ? m + ' min' : m < 1440 ? Math.round(m / 6) / 10 + ' h' : Math.round(m / 144) / 10 + ' days';

/** Overview: what needs attention, how the accounts are doing, and managed vs member activity. attrs: state, go(tab) */
export default class OverviewTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.days = 30;
    this.data = null;
    this.load();
  }
  load() {
    return api('GET', '/overview?days=' + this.days).then(r => this.data = r).catch(() => this.data = {
      error: true
    }).finally(() => m.redraw());
  }
  view() {
    const d = this.data;
    if (!d) return m(LoadingIndicator, null);
    if (d.error) return m("p", {
      className: "VEC-empty"
    }, "Couldn't load the overview.");
    const go = this.attrs.go;
    const tile = (n, label, tab) => m("button", {
      type: "button",
      className: "VEC-tile",
      onclick: tab ? () => go(tab) : null
    }, m("strong", null, n), m("span", null, label));
    const a = d.activity;
    const share = (x, y) => x + y ? Math.round(x * 100 / (x + y)) : 0;
    return m("div", {
      className: "VEC-overview"
    }, m("div", {
      className: "VEC-row-head"
    }, m("h3", null, "Needs attention"), m("select", {
      className: "FormControl VEC-inline-select",
      value: this.days,
      onchange: e => {
        this.days = parseInt(e.target.value, 10);
        this.data = null;
        this.load();
      }
    }, [[7, 'Last 7 days'], [30, 'Last 30 days'], [90, 'Last 90 days'], [365, 'Last year']].map(_ref => {
      let [v, l] = _ref;
      return m("option", {
        value: v
      }, l);
    }))), m("div", {
      className: "VEC-tiles"
    }, tile(d.inboxPending, 'replies & mentions to handle', 'inbox'), tile(d.drafts.pending, 'drafts waiting for review', 'drafts'), tile(d.drafts.approved, 'approved, not yet out', 'drafts'), tile(d.scheduled, 'scheduled', 'scheduler'), d.drafts.failed ? tile(d.drafts.failed, 'failed to publish', 'scheduler') : null), m("h3", null, "In the period"), m("div", {
      className: "VEC-tiles"
    }, tile(d.accounts.active + ' / ' + d.accounts.total, 'accounts active' + (d.accounts.paused ? ' (' + d.accounts.paused + ' paused)' : ''), 'accounts'), tile(d.published, 'drafts published'), tile(fmtMin(d.avgResponseMinutes), 'average time to answer a member')), m("div", {
      className: "VEC-card"
    }, m("h3", null, "Members vs Voucha Team"), m("p", {
      className: "VEC-help"
    }, "Forum activity in the period. Voucha Team posts are counted separately so members' own activity stays visible."), m("div", {
      className: "VEC-split"
    }, m("div", null, m("strong", null, a.memberPosts), " member posts \xB7 ", m("strong", null, a.managedPosts), " Voucha Team posts (", share(a.managedPosts, a.memberPosts), "% of all posts)"), m("div", {
      className: "VEC-bar"
    }, m("span", {
      style: {
        width: share(a.memberPosts, a.managedPosts) + '%'
      }
    })), m("div", null, m("strong", null, a.memberDiscussions), " member discussions \xB7 ", m("strong", null, a.managedDiscussions), " Voucha Team discussions (", share(a.managedDiscussions, a.memberDiscussions), "%)"), m("div", {
      className: "VEC-bar"
    }, m("span", {
      style: {
        width: share(a.memberDiscussions, a.managedDiscussions) + '%'
      }
    })))), m("div", {
      className: "VEC-card"
    }, m("h3", null, "By account"), d.perAccount.length ? m("table", {
      className: "VEC-table"
    }, m("thead", null, m("tr", null, m("th", null, "Account"), m("th", null, "Discussions"), m("th", null, "Replies"), m("th", null, "Member replies drawn"), m("th", null, "Members engaged"), m("th", null, "Likes from members"), m("th", null, "Avg time to answer"))), m("tbody", null, d.perAccount.map(r => m("tr", null, m("td", null, r.name, r.status === 'paused' ? ' (paused)' : ''), m("td", null, r.discussions), m("td", null, r.replies), m("td", null, m("strong", null, r.memberReplies)), m("td", null, r.membersEngaged), m("td", null, r.likes == null ? '—' : r.likes), m("td", null, fmtMin(r.avgResponseMinutes)))))) : m("p", {
      className: "VEC-empty"
    }, "No accounts yet.")), m("div", {
      className: "VEC-card"
    }, m("h3", null, "Discussions where members joined in most"), d.topDiscussions.length ? m("ol", {
      className: "VEC-recall"
    }, d.topDiscussions.map(t => m("li", null, m("a", {
      href: '/d/' + t.discussionId,
      target: "_blank",
      rel: "noopener"
    }, t.title), " ", m("span", {
      className: "VEC-muted"
    }, "\xB7 ", t.memberReplies, " member replies from ", t.members, " members")))) : m("p", {
      className: "VEC-help"
    }, "Nothing yet in this period.")), d.pollVotes ? m("div", {
      className: "VEC-card"
    }, m("h3", null, "Poll votes"), m("p", {
      className: "VEC-help"
    }, "Managed accounts can't vote (they can't sign in), but ", d.pollVotes, " vote", d.pollVotes === 1 ? '' : 's', " from before they were brought in still count in poll results."), m(Button, {
      className: "Button",
      onclick: () => this.removeVotes(d.pollVotes)
    }, "Remove them from poll results")) : null);
  }
  removeVotes(n) {
    if (!window.confirm('Remove ' + n + ' poll votes cast by managed accounts and recount those polls?')) return;
    api('POST', '/overview/remove-poll-votes?days=' + this.days).then(r => {
      this.data = r;
      app.alerts.show({
        type: 'success'
      }, 'Removed ' + r.removedVotes + ' votes.');
    }).catch(() => {}).finally(() => m.redraw());
  }
}